import React, { useState } from 'react';
import './App.css';
import MapCountries from './components/MapCountries';

function App() {
  const [showMarkers, setShowMarkers] = useState(true);
  const apiUrl = "https://backo.uic.org/api/companies/uicmembers";

  const toggleView = () => {
    setShowMarkers(!showMarkers);
  };

  return (
    <div className="App">
      <MapCountries apiUrl={apiUrl} />
      {/* <Button 
        onClick={toggleView} 
        icon={<SwapOutlined />}
        style={{
          position: 'absolute', 
          top: '10px', 
          left: '10px', 
          zIndex: 1000
        }}
      >
        {showMarkers ? 'By Countries' : 'Markers'}
      </Button>

      {showMarkers ? 
        <MapMarkers apiUrl={apiUrl} /> : 
        <MapCountries apiUrl={apiUrl} />
      } */}
    </div>
  );
}

export default App;

